// https://github.com/streamich/react-use/blob/master/docs/createReducerContext.md
import createReducerContext from "react-use/lib/factory/createReducerContext";

const initialReducerState = {
  contactForm: {
    visible: false,
    sent: false,
    target: null,
    inputs: {
      name: "",
      email: "",
      phone: "",
      company: "",
      message: "",
      reason: ""
    },
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case "contactFormInput":
      return {
        ...state,
        contactForm: {
          ...state.contactForm,
          inputs: {
            ...state.contactForm.inputs,
            ...action.payload,
          },
        },
      };

      case "contactFormReset":
      return {
        ...state,
        contactForm: {
          ...state.contactForm,
          inputs: initialReducerState.contactForm.inputs,
          sent: false,
        },
      };

    default:
      throw new Error();
  }
};

const [useReducer, ReducerProvider] = createReducerContext(reducer, initialReducerState);

export { ReducerProvider, initialReducerState };

export default useReducer;
